"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const commonTabs_1 = require("./commonTabs");
exports.EspNav = ({ activeTab, espId, esp }) => {
    return (react_1.default.createElement(reusables_1.NavPills, { activeTab: activeTab, queryDetailLayout: true, center: true, tabs: [
            ...commonTabs_1.commonLeftTabs(espId, esp.integrationType),
            ...commonTabs_1.commonRightTabs(espId),
        ] }));
};
//# sourceMappingURL=EspNav.js.map